import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbcCore, ConvertHelper } from '@barthauer/abc/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { BceService, GroupPacket } from '@barthauer/abc/management/configuration-explorer';
import { AbcDropDownBoxComponent } from '@barthauer/abc/ui-components';
import { ValueChangedEvent } from 'devextreme/ui/drop_down_box';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DmlDocument, DMLService } from '../../services/dml.service';

@Component({
  selector: 'configuration-page',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  standalone: false,
})
export class ConfigurationComponent implements OnInit {
  @ViewChild('configCombobox', { static: true })
  configCombobox!: AbcDropDownBoxComponent;
  private unsubscribe$: Subject<void> = new Subject<void>();
  USER_CONFIG_SELECT_KEY: string = 'SelectUserConfig';
  Valid: string;
  checked = false;
  usingStrang: boolean = false;
  configDocs: DmlDocument[] = [];
  configGUIItems: DmlDocument[] = [];
  public res = ResourceSet.Empty;
  itemName: string = '';

  constructor(
    private bceService: BceService,
    private dmlService: DMLService,
    private resourceService: ResourceManagerService,
    private abcCore: AbcCore
  ) {
    this.dmlService.getPredefinedDMLQueriesFromCurrentProfile().subscribe({
      next: (result) => {
        const queries = result?.documents;
        if (queries && queries.length > 0) {
          this.configDocs = queries;
        } else {
          this.configDocs = this.dmlService.predefinedDMLDocuments;
        }
        this.appendUserSelectionItem(result?.allowCustomDocuments);
      },
      error: (err) => {
        this.configDocs = this.dmlService.predefinedDMLDocuments;
        console.error(err);
      },
    });
  }

  async ngOnInit(): Promise<void> {
    this.queryIfUsingStrang();
    this.res = await this.resourceService.getResourceSet('opera-wizards');
    this.configCombobox.abcGrid.showColumnHeaders = false;
  }

  appendUserSelectionItem(allowCustomDocuments: boolean) {
    if (this.configGUIItems) {
      this.configGUIItems = [];
      this.configGUIItems.push(...this.configDocs);
      if (allowCustomDocuments) {
        const txt = this.res.get(this.USER_CONFIG_SELECT_KEY);
        const userSelectItem: DmlDocument = {
          name: txt,
          id: this.USER_CONFIG_SELECT_KEY,
        };
        this.configGUIItems.push(userSelectItem);
      }
    }
  }

  openBceWindow() {
    this.bceService.bceOpen();
  }

  queryIfUsingStrang() {
    this.dmlService.isUsingStrang().subscribe((usingS) => (this.usingStrang = usingS));
  }

  private _configId?: string;
  @Input() public set configId(id: string | undefined) {
    if (id && this._configId !== id) {
      this._configId = id;
    }
  }

  public get configId(): string | undefined {
    return this._configId;
  }

  onConfigChanged(eventArgs: ValueChangedEvent): void {
    const selectedId = ConvertHelper.toString(eventArgs.value);
    if (selectedId !== this.USER_CONFIG_SELECT_KEY) {
      this.configId = selectedId;
    } else {
      this.selectUserDocumentFromBCE();
    }
  }

  selectUserDocumentFromBCE() {
    this.bceService
      .selectDocument(GroupPacket.GROUP_ID_OPATHQUERIES)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data: any) => {
          const queryId = data.Id;
          const queryName = data.Designation;
          const newItem: DmlDocument = { name: queryName, id: queryId };
          this.appendUserConfigItem(newItem);
          this.itemName = newItem.name;
        },
        error: (error) => {
          this.abcCore.error.publish(error);
        },
      });
  }

  appendUserConfigItem(newItem: DmlDocument) {
    const index = this.configDocs.findIndex((item) => item.id === newItem.id);
    if (index === -1) {
      this.configDocs.push(newItem);
      this.appendUserSelectionItem(true);
    }
    setTimeout(() => {
      this.configId = newItem.id;
    }, 50);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
